module.exports = "voucherDiscount: {{transactionDiscountCode}},\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/Wizard/Snippet/snippets/transactionDiscountCode.html
// module id = 2158
// module chunks = 0